import { useCallback } from 'react'
import { User, UserGroup } from 'schema'
import { useProjectContext } from 'context/ProjectContext'

/**
 * within a project we want to treat users that have been unassigned from that
 * project as tho they have been deleted
 *
 * a callback that takes a {@link DeletedUser} and returns true if the given
 * user has been unassigned OR actually deleted
 */
export function useUserDeleted() {
  const { userGroups: projectUserGroups } = useProjectContext()
  const callback = useCallback<(user: DeletedUser) => boolean>(
    ({ deleted, userGroups }) =>
      deleted === true ||
      userGroups?.every(
        ({ id }) => !projectUserGroups.map(({ id }) => id).includes(id)
      ),
    [projectUserGroups]
  )
  return callback
}

export type DeletedUser = Pick<User, 'deleted'> & {
  userGroups: Pick<UserGroup, 'id'>[]
}
